import script from "./PriceDetailsTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./PriceDetailsTable.vue?vue&type=script&lang=ts&setup=true"

import "./PriceDetailsTable.vue?vue&type=style&index=0&id=49b3d3ba&lang=scss"

const __exports__ = script;

export default __exports__